import { Scope } from '@sentry/react'

export const sentryErrorBoundaryOptions = {
    beforeCapture: (scope: Scope, error: Error | null, componentStack: string | null) => {
        scope.setTag('error', error?.message)
        scope.setTag('callstack', componentStack)
    },
}
